angular.module('bmsApp.resource')
	.controller('ResourceDirectoryMoveDialogCtrl', [
		'notify',
		'ResourceSvc',
		'$modalInstance',
		'directory',
		function (notify,
				  ResourceSvc,
				  $modalInstance,
				  directory) {

			var self = this;
			angular.extend(self, {
				loading: false,
				promise: undefined,
				directory: directory,
				methods: {
					init: init,
					open: directoryOpen,
					cancel: cancel,
					submit: submit
				}
			});

			function init() {
				// open the destination list, starting where this directory is currently located
				directoryOpen(self.directory.parent ? self.directory.parent.id : null);
			}

			function directoryOpen(id) {
				self.loading = true;
				return ResourceSvc.directory.read({
					id: id,
					except: self.directory.id,
					group: 'my_files'
				})
					.then(function (response) {
						self.currentDir = response.data.current_directory;
						self.childDirs = response.data.child_directory_collection;
						self.loading = false;

						return response;
					}, function (errors) {
						ResourceSvc.displayErrors(errors);
					});
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				self.promise = ResourceSvc.directory.save(angular.extend(self.directory, {
					parent: self.currentDir
				}));
				self.promise.then(function () {
					notify({
						message: 'Folder moved successfully.'
					});
					$modalInstance.close();
				}, function (errors) {
					ResourceSvc.displayErrors(errors);
				});
			}

		}
	]);
